import { render, staticRenderFns } from "./informativos.vue?vue&type=template&id=5fb6af0f"
import script from "./informativos.vue?vue&type=script&lang=js"
export * from "./informativos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports